import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import IntlMessages from "util/IntlMessages";

function useErrorHandler() {
	const [errorList, setErrorList] = useState([]);

	const setErrors = (newErrors) => {
		if (!newErrors) return;
		const errorsArray = Array.isArray(newErrors) ? newErrors : [newErrors];
		setErrorList((state) => [...state, ...errorsArray]);
	};

	const resetErrors = () => {
		setErrorList([]);
	};

	useEffect(() => {
		errorList.forEach((err) => {
			toast.error(err);
		});

		if (errorList.length > 0) {
			resetErrors();
		}
	}, [errorList]);

	const extractErrorSlugs = (response) => {
		const { data } = response || {};

		if (data?.message === "validation-error" && data?.data) {
			return Object.entries(data.data).flatMap(([key, value]) => {
				const messages = Array.isArray(value) ? value : [value];

				return messages.map((msg, index) => {
					const safeMsg = String(msg || "");
					const slug = safeMsg.replace(/\s+/g, "-");

					return (
						<IntlMessages
							key={`${key}-${slug}-${index}`}
							id={`error.${slug}`}
							defaultMessage={safeMsg || `${key} error`}
						/>
					);
				});
			});
		}

		const genericSlug = data?.message || "unspecific";
		return [
			<IntlMessages
				key="generic-error"
				id={`error.${genericSlug}`}
				defaultMessage={<IntlMessages id="error.unspecific" />}
			/>,
		];
	};

	return { errors: errorList, setErrors, extractErrorSlugs, resetErrors };
}

export default useErrorHandler;
